module.exports = __webpack_public_path__ + "img/switch2.a4a1bcb4.svg";